export const SET_FORECASTED_REVENUE = "SET_FORECASTED_REVENUE";
export const SET_FORECASTED_DOE = "SET_FORECASTED_DOE";
